import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';

export default function LoginPage() {
  const { login } = useAuth();
  const { t, lang, switchLang } = useLang();
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await login(email, password); navigate('/'); }
    catch { setError(t('login_error')); }
    finally { setLoading(false); }
  }

  return (
    <div className="login-page">
      <div className="card shadow-sm" style={{ width: 360 }}>
        <div className="card-body p-4">
          <div className="d-flex justify-content-end mb-3">
            <div className="lang-toggle">
              <button className={lang === 'nl' ? 'active' : ''} onClick={() => switchLang('nl')}>NL</button>
              <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')}>EN</button>
            </div>
          </div>
          <div className="text-center mb-4">
            <img src="/logo-fdconsult.png" alt="FDConsult" style={{ height: 56, maxWidth: '100%' }} />
            <div className="text-muted small mt-2 fw-medium" style={{ letterSpacing: '0.05em' }}>
              EngieTool · {t('app_subtitle')}
            </div>
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label small fw-medium">{t('login_email')}</label>
              <input type="email" className="form-control" value={email}
                onChange={e => setEmail(e.target.value)} autoFocus required />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-medium">{t('login_password')}</label>
              <input type="password" className="form-control" value={password}
                onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary w-100 mt-1" disabled={loading}>
              {loading ? <span className="spinner-border spinner-border-sm me-2" /> : null}
              {t('login_submit')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
